import Vue from 'vue'
import Vuex from 'vuex'
// import dataCenter from './modules/dataCenter'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    access_token: '',
    UserId: '',
    // loginInfo: {},
    // userInfo: {},
    // projectId: null,
    loading: false,
    HVAC_EnergyConsumption_Annual: {}
  },
  getters: {},
  mutations: {
    SAVE_HVAC_EnergyConsumption_Annual (state, val) {
      state.HVAC_EnergyConsumption_Annual = val
    },
    // GET_ACCESS_TOKEN (state, val) {
    //   state.access_token = val
    // },
    // GET_LOGIN_INFO (state, val) {
    //   state.loginInfo = val
    //   sessionStorage.setItem('userId', val)
    // },
    // GET_USER_INFO (state, val) {
    //   state.userInfo = val
    // },

    // SET_LOADING (state, val) {
    //   state.loading = val
    // },

    // GET_AUTHORITYV2 (state, data) {
    //   state.authorityV2 = data
    // },

    // 清除token
    CLEAR_TOKEN (state, val) {
      state.access_token = ''
    }
  },
  actions: {},
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer: state => {
        return {
          saveInput: state.saveInput
        }
      }
    })
  ],
  modules: {
    // dataCenter,
    plugins: []
  }
})
